import { InfoIconNotFilled } from "@/styles/icons/InfoIconNotFilled";
import { Flex } from "@chakra-ui/react"
import { Tooltip as BarteTooltip } from "barte-design-system";
interface TooltipProps {
    iconSize?: number;
    color?: string;
    label?: string;
    placement?: "top" | "bottom" | "left" | "right";
}
export function Tooltip( {iconSize = 10,color, label, placement } :TooltipProps) {
    return(
        <BarteTooltip placement={placement} label={label}>
            <Flex>
                <InfoIconNotFilled 
                    size={iconSize} 
                    color={color}
                />
            </Flex>
        </BarteTooltip>
    )
}